module.exports = __webpack_public_path__ + "img/credit.f47c8761.jpg";